import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ChevronNavCommand from './chevronnavcommand';

export default class ChevronNavEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add( 'chevronnav', new ChevronNavCommand( editor, 'chevronnav' ) );
  }
}
